/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_QuestionInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_2_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between a workbook and a worksheet?`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_2_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作簿与工作表有什么区别？`)
};

/**
* | output |
* | --- |
* | "What is the difference between a workbook and a worksheet?" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_2_question = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_2_question(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_2_question(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_2_question as "gc.search_guides.what_is_gridcraft.sections.8.questions.2.question" }